import { Fragment } from 'react';
import TranslationText from '@Components/Utilities/TranslationText';

const ShippingInfo = (props) => {

    const buildFulfillmentOptionsDisplay = () => {
        let fulfillmentOptionsKeys = props.FulfillmentOptions.map(option => getFulfillmentOptionKey(option));
        return fulfillmentOptionsKeys.map((value, index) =>
            <>
                <Fragment key={value}>
                    <div className='detail__shipping-option'>
                        <TranslationText tKey={value} />
                    </div>
                </Fragment>
            </>
        );
    };

    const getFulfillmentOptionKey = (option) => {
        switch (option) {
            case 'InStorePickup':
                return 'sandhills.instorepickup';
            case 'CurbsidePickup':
                return 'sandhills.curbsidepickup';
            default:
                return 'sandhills.shippingavailable';
        }
    };

    return (
        <div className='detail-shipping'>
            <div className='detail-shipping__header'>
                <h3 className='detail-shipping__heading'>{translator.translate('sandhills.crm.dscrm.shippinginformation')}</h3>
            </div>
            <div className='detail-shipping__details'>
                {buildFulfillmentOptionsDisplay()}
                {props.IsFreeShipping &&
                    <div className='detail__shipping-option'>
                        <TranslationText tKey={'sandhills.freeshipping'} />
                        <i className='fas fa-truck detail__shipping-icon' />
                    </div>}
            </div>
        </div>
    );
};

export default ShippingInfo;